import { type RouteConfig } from 'vue-router'

import FeatureFlags from '@/featureFlags'

export const integrationsRouter: RouteConfig[] = FeatureFlags.useNewIntegrations
  ? [
      {
        children: [
          {
            component: async () =>
              import('../views/GoogleBusinessDetailView.vue'),
            meta: {
              inDemo: true,
            },
            name: `brand.integrations.gmb.detail`,
            path: 'google/:locationId',
            props: (route) => ({
              locationId: route.params.locationId,
            }),
          },
        ],
        component: async () => import('../views/IntegrationsMainView.vue'),
        meta: {
          inDemo: true,
          title: 'website.integrations',
        },
        name: 'brand.integrations',
        path: 'integrations',
      },
    ]
  : [
      {
        children: [
          {
            component: async () =>
              import(
                '@/views/BrandView/IntegrationViews/IntegrationBrandSettingsView.vue'
              ),
            meta: {
              inDemo: true,
            },
            name: `brand.integrations.gmb`,
            path: 'google',
          },
          {
            component: async () =>
              import(
                '@/views/BrandView/IntegrationViews/IntegrationLocationSettingsView.vue'
              ),
            meta: {
              inDemo: true,
            },
            name: `brand.integrations.gmb.location-detail`,
            path: 'locations/:locationId',
          },
        ],
        component: async () =>
          import(
            '@/views/BrandView/IntegrationViews/IntegrationSettingsView.vue'
          ),
        meta: {
          inDemo: true,
          title: 'website.integrations',
        },
        name: `brand.integrations`,
        path: 'integrations',
        props: {
          activeTab: `brand.integrations`,
          scope: 'brand',
        },
        redirect: { name: `brand.integrations.gmb` },
      },
    ]
